// Fondmetal Wheel Finder — Ad Hoc 3D Motorsport
// SKU indices
const F={code:0,model:1,diam:2,size:3,et:4,pcd:5,cb:6,fin:7,avail:8,timing:9,price:10,orig:11,disc:12};
let activeModel=null,activeCar=null,currentSku=null;

// ── SLIDESHOW ──────────────────────────────────────────────────────────
let slide=0;
function initSlides(){
  var slides=document.querySelectorAll('.hslide');
  var dots=document.querySelectorAll('.hdot');
  if(!slides.length) return;
  function goSlide(n){
    slide=n;
    slides.forEach(function(s,i){s.classList.toggle('on',i===n);});
    dots.forEach(function(d,i){d.classList.toggle('on',i===n);});
  }
  window.goSlide=goSlide;
  setInterval(function(){goSlide((slide+1)%slides.length);},5500);
}

// ── INIT ───────────────────────────────────────────────────────────────
(function init(){
  initSlides();
  var sm=document.getElementById('s-mfr');
  if(!sm) return;
  Object.keys(CARS).sort().forEach(function(m){
    var o=document.createElement('option');o.value=m;o.textContent=m;sm.appendChild(o);
  });
  sm.addEventListener('change',onMfr);
  document.getElementById('s-mod').addEventListener('change',onMod);
  document.getElementById('s-go').addEventListener('click',doSearch);
  document.getElementById('s-rst').addEventListener('click',resetSearch);
  var lines=['all','9 PERFORMANCE','SUPER TUNING','INSPIRED','FITTIPALDI','FORGED','GEAR OFF ROAD','OFF-ROAD','PROFESSIONAL','CLASSIC'];
  var lbl={all:'Tutti','9 PERFORMANCE':'9 Performance','SUPER TUNING':'Super Tuning','INSPIRED':'Inspired','FITTIPALDI':'Fittipaldi','FORGED':'Forged','GEAR OFF ROAD':'Gear Off Road','OFF-ROAD':'Off-Road','PROFESSIONAL':'Professional','CLASSIC':'Classic'};
  var pd=document.getElementById('line-pills');
  if(pd) lines.forEach(function(l){
    var b=document.createElement('button');
    b.className='pill'+(l==='all'?' on':'');
    b.textContent=lbl[l]||l;
    b.addEventListener('click',function(){
      document.querySelectorAll('.pill').forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      activeCar=null;closeDet();
      renderGrid(CARDS.filter(function(c){return l==='all'||c.l===l;}),false,null,null);
    });
    pd.appendChild(b);
  });
  document.getElementById('d-diam').addEventListener('change',onDiam);
  document.getElementById('d-fin').addEventListener('change',onFin);
})();

// ── TABS ───────────────────────────────────────────────────────────────
function switchTab(t,btn){
  document.querySelectorAll('.tab').forEach(function(b){b.classList.remove('on');});btn.classList.add('on');
  document.querySelectorAll('.tbody').forEach(function(b){b.classList.remove('on');});
  document.getElementById('tb-'+t).classList.add('on');
  activeCar=null;closeDet();document.getElementById('results').innerHTML='';
}

// ── CAR SEARCH ─────────────────────────────────────────────────────────
function onMfr(){
  var v=document.getElementById('s-mfr').value;
  var ms=document.getElementById('s-mod');
  ms.innerHTML='';
  if(!v){ms.innerHTML='<option value="">— Prima seleziona marca —</option>';ms.disabled=true;document.getElementById('s-go').disabled=true;return;}
  ms.disabled=false;ms.innerHTML='<option value="">— Seleziona modello —</option>';
  (CARS[v]||[]).forEach(function(m){var o=document.createElement('option');o.value=m;o.textContent=m;ms.appendChild(o);});
  document.getElementById('s-go').disabled=true;
}
function onMod(){document.getElementById('s-go').disabled=!document.getElementById('s-mod').value;}
function doSearch(){
  var mfr=document.getElementById('s-mfr').value,mod=document.getElementById('s-mod').value;
  if(!mfr||!mod)return;
  activeCar=mfr+'|'+mod;closeDet();
  var compat=new Set(FIT[activeCar]||[]);
  var matching=CARDS.filter(function(c){return compat.has(c.n);});
  renderGrid(matching,true,compat,'<strong>'+mfr+' '+mod+'</strong> — '+matching.length+' cerchi compatibili');
}
function resetSearch(){
  document.getElementById('s-mfr').value='';
  document.getElementById('s-mod').innerHTML='<option value="">— Prima seleziona marca —</option>';
  document.getElementById('s-mod').disabled=true;document.getElementById('s-go').disabled=true;
  activeCar=null;closeDet();document.getElementById('results').innerHTML='';
}

// ── GRID ───────────────────────────────────────────────────────────────
function renderGrid(cards,compat,cs,label){
  var r=document.getElementById('results');
  if(!cards.length){r.innerHTML='<div class="empty">Nessun cerchio trovato</div>';return;}
  r.innerHTML='<div class="rbar"><div class="info">'+(label||cards.length+' modelli')+'</div></div><div class="grid">'+cards.map(function(c){return cardHTML(c,compat&&cs&&cs.has(c.n));}).join('')+'</div>';
}
function cardHTML(c,compat){
  var img=c.img?'<img src="'+c.img+'" alt="'+c.n+'" loading="lazy" onerror="this.style.opacity=0">':'';
  var cb=compat?'<div class="compat-tag">&#x2713; compatibile</div>':'';
  var db=c.disc>0?'<div class="disc-tag">-'+(c.disc*100).toFixed(0)+'%</div>':'';
  var sizes=c.sz.map(function(s){return '<span class="stag">'+s+'"</span>';}).join('');
  var ph='';
  if(c.pmin>0){
    if(c.disc>0){ph='<div class="c-price"><span class="price-old"><span class="price-from">da </span>€'+c.pmin_orig+'</span><span class="price-new"><span class="price-from">da </span>€'+c.pmin+'<span class="price-vat">IVA inc.</span></span></div>';}
    else{ph='<div class="c-price"><span class="price-base"><span class="price-from">da </span>€'+c.pmin+'<span class="price-vat">IVA inc.</span></span></div>';}
  }else ph='<div class="c-price"><span style="font-size:12px;color:var(--t3)">Su richiesta</span></div>';
  return '<div class="card" data-m="'+encodeURIComponent(c.n)+'"><div class="c-img">'+img+cb+db+'</div><div class="c-body"><div class="c-line">'+c.l+'</div><div class="c-name">'+c.n.replace(/</g,'&lt;')+'</div><div class="c-sizes">'+sizes+'</div>'+ph+'</div></div>';
}
document.addEventListener('click',function(e){var c=e.target.closest('.card');if(c)openDet(decodeURIComponent(c.dataset.m));});

// ── DETAIL ─────────────────────────────────────────────────────────────
function getFilteredSkus(){
  if(!activeModel)return[];
  var all=SKUS.filter(function(s){return s[F.model]===activeModel;});
  if(!activeCar)return all;
  var key=activeCar+'|'+activeModel;
  var rfCodes=CC.rf&&CC.rf[key];
  if(rfCodes&&rfCodes.length>0){
    var allowed=new Set(rfCodes);
    return all.filter(function(s){return allowed.has(s[F.code]);});
  }
  var appFilter=CC.app&&CC.app[key];
  if(appFilter&&appFilter.length>0){
    return all.filter(function(s){return appFilter.some(function(a){return a.d===s[F.diam]&&a.et===s[F.et];});});
  }
  return all;
}
function openDet(name){
  var card=CARDS.find(function(c){return c.n===name;});if(!card)return;
  activeModel=name;
  document.getElementById('det-img').src=card.img;
  document.getElementById('det-line').textContent=card.l;
  document.getElementById('det-name').textContent=name;
  var ms=getFilteredSkus();
  var diams=[...new Set(ms.map(function(s){return s[F.diam];}))].sort(function(a,b){return a-b;});
  document.getElementById('d-diam').innerHTML=diams.map(function(d){return '<option value="'+d+'">'+d+'"</option>';}).join('');
  onDiam();
  var p=document.getElementById('det');p.classList.add('on');
  p.scrollIntoView({behavior:'smooth',block:'start'});
}
function onDiam(){
  if(!activeModel)return;
  var d=parseInt(document.getElementById('d-diam').value);
  var ms=getFilteredSkus().filter(function(s){return s[F.diam]===d;});
  var fins=[...new Set(ms.map(function(s){return s[F.fin];}))].filter(Boolean).sort();
  document.getElementById('d-fin').innerHTML=fins.map(function(f){return '<option>'+f+'</option>';}).join('');
  onFin();
}
function onFin(){
  if(!activeModel)return;
  var d=parseInt(document.getElementById('d-diam').value),fin=document.getElementById('d-fin').value;
  var ms=getFilteredSkus().filter(function(s){return s[F.diam]===d&&s[F.fin]===fin;});
  var ss=document.getElementById('d-size');
  ss.innerHTML=ms.map(function(s,i){return '<option value="'+i+'">'+s[F.size]+' ET'+s[F.et]+' '+s[F.pcd]+'</option>';}).join('');
  showSku(ms[0]);
  ss.onchange=function(){showSku(ms[parseInt(this.value)]);};
}
function sf(k,v){return '<div class="sf"><span class="k">'+k+'</span><span class="v">'+v+'</span></div>';}
function showSku(sku){
  currentSku=sku;
  if(!sku){document.getElementById('skubox').innerHTML='';return;}
  var av=sku[F.avail];
  var chip=av>10?'<span class="chip g">&#9679; '+av+' pz disponibili</span>':av>0?'<span class="chip a">&#9650; '+av+' pz — ultime unità</span>':'<span class="chip b">&#8635; Su ordine — previsto '+sku[F.timing]+'</span>';
  var disc=sku[F.disc]||0,orig=sku[F.orig]||0,price=sku[F.price]||0;
  var pb;
  if(disc>0&&orig>0){pb='<div class="sku-prices"><div class="sku-old">€'+orig+'</div><div class="sku-new">€'+price+'</div><div class="sku-disc-badge">-'+(disc*100).toFixed(0)+'% sconto Ad Hoc</div></div>';}
  else if(price>0){pb='<div class="sku-prices"><div class="sku-new no-disc">€'+price+'</div></div>';}
  else pb='<div class="sku-prices"><div class="sku-new no-disc">&#8212;</div></div>';

  var cartSection=price>0
    ?'<div style="margin-top:18px;padding-top:16px;border-top:1px solid var(--bd)"><button id="btn-cart" class="btn btn-y" style="width:100%;height:50px;font-size:15px" onclick="addToCart(currentSku)">&#128722;&nbsp; Acquista ora — 4 cerchi</button><div style="font-size:11px;color:var(--t3);margin-top:6px;text-align:center">Set da 4 cerchi &middot; Spedizione calcolata al checkout</div></div>'
    :'<div style="margin-top:18px;padding-top:16px;border-top:1px solid var(--bd)"><a href="/pages/contatti" class="btn btn-y" style="width:100%;height:50px;font-size:15px;display:flex;align-items:center;justify-content:center;text-decoration:none">Richiedi preventivo</a></div>';

  document.getElementById('skubox').innerHTML=
    '<div class="skutop">'+pb+'<div><div class="skupsub">IVA 22% inclusa &middot; al cerchio</div><div style="margin-top:8px">'+chip+'</div></div></div>'
    +'<div class="skuflds">'+sf('Codice',sku[F.code])+sf('Misura',sku[F.size])+sf('ET',sku[F.et])+sf('Foratura',sku[F.pcd])+sf('CB',sku[F.cb]||'&#8212;')+sf('Finitura',sku[F.fin]||'&#8212;')+'</div>'
    +cartSection;
}
function closeDet(){document.getElementById('det').classList.remove('on');activeModel=null;}

// ── ADD TO CART ────────────────────────────────────────────────────────
function addToCart(sku){
  if(!sku)return;
  var btn=document.getElementById('btn-cart');
  if(btn){btn.disabled=true;btn.textContent='Preparazione...';}

  var handle='fondmetal-'+sku[F.model]
    .toLowerCase()
    .replace(/[\s]+/g,'-')
    .replace(/[\(\)\/\.]+/g,'-')
    .replace(/-+/g,'-')
    .replace(/^-|-$/g,'');

  fetch('/products/'+handle+'.js')
    .then(function(r){if(!r.ok)throw new Error('Prodotto non trovato: '+handle);return r.json();})
    .then(function(product){
      var size=sku[F.size],fin=sku[F.fin],variant=null;
      for(var v of product.variants){if(v.option1===size&&v.option2===fin){variant=v;break;}}
      if(!variant)for(var v of product.variants){if(v.option1===size){variant=v;break;}}
      if(!variant)variant=product.variants[0];
      if(!variant)throw new Error('Variante non trovata');
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({id:variant.id,quantity:4,properties:{'Codice RF':sku[F.code],'ET':'ET'+sku[F.et],'Foratura':sku[F.pcd],'CB':sku[F.cb]||'-'}})});
    })
    .then(function(r){return r.json();})
    .then(function(data){
      if(data.id||data.variant_id){
        if(btn){btn.textContent='✓ Aggiunto!';btn.style.background='var(--green)';}
        setTimeout(function(){window.location.href='/cart';},700);
      }else throw new Error(data.description||'Errore');
    })
    .catch(function(err){
      if(btn){btn.disabled=false;btn.innerHTML='&#128722;&nbsp; Acquista ora — 4 cerchi';btn.style.background='';}
      console.error('Cart error:',err);
      alert('Errore: '+err.message);
    });
}
